(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auran-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('auran-offer')) {
    customElements.define('auran-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('[data-offer-copy]');
        const status = this.querySelector('[role="status"]');
        if (!button || !status) return;
        const label = button.textContent;
        const initialStatus = status.textContent;
        button.addEventListener('click', async () => {
          clearTimeout(this.resetTimer);
          button.disabled = true;
          try {
            await navigator.clipboard.writeText('AU25');
            button.textContent = this.dataset.copied;
            status.textContent = this.dataset.success;
          } catch {
            button.textContent = label;
            status.textContent = this.dataset.failure;
          } finally {
            button.disabled = false;
          }
          this.resetTimer = setTimeout(() => {
            button.textContent = label;
            status.textContent = initialStatus;
          }, 5000);
        });
      }

      disconnectedCallback() {
        clearTimeout(this.resetTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
